import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormText from "../../../../../../components/Forms/FormText";

function Opacity({ name, required }: JSInputProps) {
  return (
    <FormText
      fieldProps={{
        min: 0,
        max: 1,
        stepSize: 0.05,
      }}
      name={name}
      rules={{ required }}
    />
  );
}

export const JSOpacityComponent: JSInputComponent = {
  Component: Opacity,
  handlesCssProperties: ["opacity"],
};
